// hooks/useReportData.js
import { useQuery } from "react-query";
import axios from "axios";
import https from "https";
import log from "../../utils/log";
import metaData from "../../data/metaData";
import useAuthStore from "../../states/useAuth";

const useReport = (enabled = true, queryKey, url, data) => {
  const { user, auth } = useAuthStore();

  return useQuery(
    queryKey,
    async () => {
      log.debug(`fetch POST/${url}`);
      const res = await axios.post(metaData.serverURL + url, data, {
        headers: { Authorization: auth.jwt },
        httpsAgent: new https.Agent({ keepAlive: true, keepAliveMsecs: 60000 }),
      });
      return res.data;
    },
    {
      enabled,
      staleTime: 10000, // Data is considered fresh for 10 seconds
      onSuccess: (data) => log.debug(data),
      onError: (error) => log.error(error),
      select: (data) => data.map((e, i) => ({ key: i, ...e })),
      keepPreviousData: true,
    }
  );
};

export default useReport;
